'use client';

import { Divider, Menu, MenuItem } from '@mui/material';
import Link from 'next/link';
import { configuredExternalUrl } from '@/config/serverConfig';
import { useSystemConfig } from '@/hooks/useSystemConfig';

interface HelpMenuProps {
  anchorEl: null | HTMLElement;
  onClose: () => void;
}

export default function HelpMenu({ anchorEl, onClose }: HelpMenuProps) {
  const systemConfig = useSystemConfig();

  if (!systemConfig) {
    return null;
  }

  const wikiUrl = configuredExternalUrl(systemConfig.wiki);
  const bugReportUrl = configuredExternalUrl(systemConfig.bugReport);

  return (
    <Menu
      id="help-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {wikiUrl ? (
        <MenuItem key="wiki" onClick={onClose} component="a" href={wikiUrl} target="_blank" rel="noopener noreferrer">
          LiST Wiki
        </MenuItem>
      ) : null}
      {/* TEMP: remove once bug reporting is linked from a permanent in-app location */}
      {bugReportUrl ? (
        <MenuItem
          key="report-bug"
          onClick={onClose}
          component="a"
          href={bugReportUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Report a bug
        </MenuItem>
      ) : null}
      <MenuItem key="changelog" onClick={onClose} component={Link} href={systemConfig.basePath + '/changelog'}>
        Changelog
      </MenuItem>
      <Divider key="divider1" />
      <MenuItem onClick={onClose} component={Link} href={systemConfig.basePath + '/about'}>
        About
      </MenuItem>
    </Menu>
  );
}
